import styles from "./tablerowcard.module.css";
import { useHistory } from "react-router-dom";
import { TableCell, TableRow } from "@mui/material";
import dayjs from "dayjs";

const TableRowCard = ({ item }) => {
    const history = useHistory();

    return (<TableRow onClick={() => history.push('/campaign/analytics/' + item?.id)}>
        <TableCell className={`${styles.TableBodyText} ${styles.Head}`}>
            {item?.subject}
            <p>{dayjs(item?.created_at).format('ddd, MMM D, hh.mm A')} by {item?.user_name}</p>
        </TableCell>
        <TableCell className={`${styles.TableBodyText}`}>
            {item?.status === 0 && <span className={`${styles.StatusBadge} ${styles.Sending}`}>Sending</span>}
            {item?.status === 1 && <span className={`${styles.StatusBadge} ${styles.Sent}`}>Sent</span>}
        </TableCell>
        <TableCell className={`${styles.TableBodyText}`}>
            {item?.audience_name}
            <p>{item?.no_of_emails > 1 ? item?.no_of_emails + ' recipients' : item?.no_of_emails + ' recipient'}</p>
        </TableCell>
        <TableCell className={`${styles.TableBodyText}`}>
            <div className={`${styles.AnalyticsSec}`}>
                <span className={`${styles.Outer}`}><span>{item?.delivery_percentage}%</span><br />Delivery</span>
                <span className={`${styles.Outer}`}><span>{item?.open_percentage}%</span><br />Opens</span>
                <span className={`${styles.Outer}`}><span>{item?.click_percentage}%</span><br />Clicks</span>
            </div>
        </TableCell>
    </TableRow>)
}

export default TableRowCard;